export const BASE_MODAL_WIDTH = 320;
export const BASE_MODAL_HEIGHT = 420;
